export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11342.c71449ed.jpg";